import { ErrorHandler, Injectable } from '@angular/core';
import { ConnectionLostService } from '../../../pages/secure/home/services/connection-lost.service';
import { ErrorHandlerInterface } from './error-handler.interface';

@Injectable()
export class AuthorizationHandlerService implements ErrorHandlerInterface {
  private NotAuthorizedErrorCode = 401;
  constructor(private connectionService: ConnectionLostService) {}
  handleError(error: any): boolean {
    if (error.status === this.NotAuthorizedErrorCode) {
      this.connectionService.checkConnectivityStatus();

      return true;
    }
    // Handle the 404 error here if needed.
    return false;
  }
}
